/* eslint-disable no-unused-vars */
import {
  pdf,
  PDFViewer,
} from "@react-pdf/renderer";
import React, { useState } from "react";
import GlobalTable from "../../../components/global-table";
import { Box, Button, Dialog, InputField, Typography } from "../../../ppui";
import { theme } from "../../../theme";
import { logger } from "../../../utils/logger";
import {
  ContentLayout,
  ContentTable,
} from "../../style";
import { SalaryHeaders } from "./payslipreport.data";
import PayslipPdf from "./pdf-report";
import usePayslipReportService from "./use-payslip-report-service";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import PayslipReportBulkDownloadPDF from "./payslip-report-bulk-download";
import useOrgDetailsDataHook from "../../../lib/useOrgDetailsData";

function PayslipReport() {
  // const [openUploadImportModal, setOpenUploadImportModal] = useState(false);
  // const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);
  // const handleOpenUploadImportModal = () => setOpenUploadImportModal(true);
  const { 
    payslipReportListData,
    allowances,
    payslipReportSummary,
    payslipReportInputs,
    handleChange,
    openUploadImportModal,
    handleCloseUploadImportModal,
    handleOpenUploadImportModal,
    handleClickEmpName,
    payslipReportData,
    searchQuery,
    setSearchQuery,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    dataFetched
  } = usePayslipReportService()
  const {organizationInfo}=useOrgDetailsDataHook()
  logger.log(payslipReportData,"88888888")
  logger.log(payslipReportListData,"7777777777")
  logger.log(organizationInfo,"organizationInfo-000")
  const [isBulkDownloading, setIsBulkDownloading] = useState(false);
  const handleBulkDownload = async () => {
    setIsBulkDownloading(true);
    try{
      logger.log(payslipReportListData, "testy")
      const zip = new JSZip();
      for (const employee of payslipReportListData) {
        const pdfBlob = await generatePdfBlob(employee);
        zip.file(`${employee?.employee_name}_${employee?.employee_code}_Payslip.pdf`, pdfBlob);
      }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "Employee_Payslip.zip");
    }catch (error) {
      console.error("Error generating bulk download:", error);
    }finally{
      setIsBulkDownloading(false);
    }
  }

  const generatePdfBlob = async (employee) => {
    const pdfDocument = 
    <PayslipReportBulkDownloadPDF
      payslipReportData={employee}
      orgDetails={organizationInfo}
      // branchList={branchList}
      // stateList={stateList} 
    />;
    const pdfBlob = await pdf(pdfDocument).toBlob();
    return pdfBlob;
  };
  return (
    <>
      <ContentLayout>
        
        <ContentTable>
          <GlobalTable
            headers={SalaryHeaders}
            rows={payslipReportListData}
            ActiveSort={false}
            searchBox={true}
            columnManagement={false}
            avatar={true}
            stickyHeader="true"
            // FetchDataFromRow={(SalaryRows) => handleOpenUploadImportModal(SalaryRows.employee_id)}
            FetchDataFromRow={(SalaryRows) => handleClickEmpName(SalaryRows.employee_id)}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                Pay Slip 
                </Typography>
                 
              </>
            }
            actionRight={
              <>
                <InputField
                  label="Report Month"
                  name="month"
                  type="month"
                  placeholder="Type Here..."
                  valueSinc
                  // value="2024-12"
                  value={payslipReportInputs?.report_month}
                  onChange={(e)=>handleChange(e.target.value,"report_month")}
                  onKeyDown={e => e.preventDefault()}

                />
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => handleBulkDownload()}
                  disabled={dataFetched?false:true}
                  loading={isBulkDownloading}
                >
                  Bulk Download
                </Button>
              </>
            }
           
          />
        </ContentTable>
      </ContentLayout>
      {/* UploadImportModal */}
      <Dialog
        // title="Payslip of employee name (January, 2025)"
        title="Payslip"
        closeButton={true}
        action={false}
        fullWidth
        maxWidth="lg"
        bodyScroll={true}
        open={openUploadImportModal}
        onClose={handleCloseUploadImportModal}
        
      >
        <Box height="85vh" sx={{overflow:"hidden",borderRadius:theme.radius.list}}>
        <PDFViewer document={<PayslipPdf />} showToolbar={true} width="100%" height="100%" style={{border:"none"}}>
          <PayslipPdf payslipReportData={payslipReportData}/>
        </PDFViewer>
        </Box>
      </Dialog>
      {/* UploadImportModal */}
    </>
  );
};

export default PayslipReport;
